import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DiscardChangesGuard implements CanDeactivate<Discardable> {
  canDeactivate(component: Discardable): Observable<boolean> | boolean {
    if (!(component satisfies Discardable)) return true;
    return component.canSafelyDiscard();
  }
}

export interface Discardable {
  canSafelyDiscard: () => Observable<boolean> | boolean;
}
